import React, { useState, useEffect } from 'react';
import {
    Grid,
    Card,
    CardActionArea,
    CardContent,
    Typography,
    Box,
    useTheme,
    IconButton
} from '@mui/material';
import {
    AccountCircle,
    ListAlt,
    TrackChanges,
    Restaurant,
    Commute,
} from '@mui/icons-material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../lib/axios';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Announcement from '@mui/icons-material/Announcement';


const menuItems = [
    // { label: 'Profile', icon: <AccountCircle />, path: '/resident-profile' },
    { label: 'Raise Ticket', icon: <ListAlt />, path: '/res-raise-ticket' },
    { label: 'Track Ticket', icon: <TrackChanges />, path: '/res-ticket-status' },
    { label: 'Account', icon: <AccountBalanceIcon />, path: '/account' },
    { label: 'CheckIn Article', icon: <SpellcheckIcon />, path: '/checkinart' },
    { label: 'Tiffin Service', icon: <Restaurant />, path: '/food-service' },
     { label: 'Food Menu', icon: <Restaurant />, path: '/food-list' },
    { label: 'Food Service', icon: <Restaurant />, path: '/tiffin-service' },
    { label: 'Transport', icon: <Commute />, path: '/transportation' },
    { label: 'Notice Board', icon: <Announcement />, path: '/notice-board' },
];

const ResidentMenuPage = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const [bookings, setBookings] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBookingData = async () => {
            const Mobile = localStorage.getItem("Mobile");
            try {
                const response = await axiosInstance.post('TrnBooking/GetTrnBookingDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: '',
                    Flag:'',
                    MobileNo :Mobile,
                    BookNo:'',
                    PropId:1,
                });
                if (response.data.Status === 0) {
                    setBookings(response.data.Data);
                    //   if (response.data.Data.length > 0) {
                    //     setCurrentBookingIndex(0); 
                    //   }
                } else {
                    setError(response.data.Message);
                }
            } catch (err) {
                setError('Error fetching data');
            } finally {
                setLoading(false);
            }
        };
        fetchBookingData();
    }, []);


    return (
        <Box
            sx={{
                height: '85vh',
                overflowY: 'auto',
                background: 'linear-gradient(135deg, #e0e7ff 0%, #f0f4ff 100%)',
                padding: { xs: 2, sm: 4 },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <Grid container spacing={2}>
                {menuItems.map((item, index) => (
                    <Grid item xs={6} sm={4} md={3} key={index}>
                        <Card
                            elevation={0}
                            sx={{
                                background: '#fff',
                                borderRadius: 4,
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                                },
                            }}
                        >
                            <CardActionArea
                                // onClick={() => navigate(item.path)}
                                onClick={() => navigate(item.path, {
                                    state: { bookingsData: bookings }
                                })}
                            >
                                <CardContent
                                    sx={{
                                        height: 120,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            color: theme.palette.primary.main,
                                            fontSize: 36,
                                            mb: 1,
                                        }}
                                    >
                                        {React.cloneElement(item.icon, { fontSize: 'inherit' })}
                                    </Box>
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={600}
                                        align="center"
                                        sx={{ color: '#444' }}
                                    >
                                        {item.label}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Description at the bottom */}
            <Box
                sx={{
                    mt: 4,
                    textAlign: 'center',
                    color: '#666',
                    fontSize: '0.9rem',
                    px: 2,
                }}
            >
                <Typography variant="body2">
                    Welcome to your resident dashboard. Here you can manage your account, raise tickets,
                    track their status, and access various services like tiffin and transportation.
                    We're here to make your living experience smooth and enjoyable.
                </Typography>
            </Box>

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                <IconButton
                    href="https://web.whatsapp.com/"
                    target="_blank"
                    sx={{ color: '#25D366' }}
                >
                    <WhatsAppIcon />
                </IconButton>

                <IconButton
                    href="https://www.facebook.com/p/Clanbridge-100081081227035/"
                    target="_blank"
                    sx={{ color: '#1877F2' }}
                >
                    <FacebookIcon />
                </IconButton>

                <IconButton
                    href="https://twitter.com/yourcommunity"
                    target="_blank"
                    sx={{ color: '#000000ff' }}
                >
                    <XIcon />
                </IconButton>

                <IconButton
                    href="https://www.instagram.com/clanbridgeliving/?hl=en"
                    target="_blank"
                    sx={{ color: '#E1306C' }}
                >
                    <InstagramIcon />
                </IconButton>

                <IconButton
                    href="https://www.linkedin.com/company/clanbridge-living/"
                    target="_blank"
                    sx={{ color: '#0A66C2' }}
                >
                    <LinkedInIcon />
                </IconButton>

                <IconButton
                    href="https://www.youtube.com/watch?v=JybKo76BInY"
                    target="_blank"
                    sx={{ color: '#FF0000' }}
                >
                    <YouTubeIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

export default ResidentMenuPage;
